import { Text } from '@mantine/core';
import { NavLink } from 'react-router';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  children: string;
  to: string;
  size:
    | 'textXs'
    | 'textSm'
    | 'textMd'
    | 'textLg'
    | 'textXl'
    | 'displayXs'
    | 'displaySm'
    | 'displayMd'
    | 'displayLg'
    | 'displayXl'
    | 'display2xl';
  fw?: (typeof FONT_WEIGHTS)[keyof typeof FONT_WEIGHTS];
  onClick?: () => void;
  c?: string;
  target?: '_blank' | '_self' | '_parent' | '_top';
};

export default function Link({
  children,
  to,
  size = 'textMd',
  fw = FONT_WEIGHTS.medium,
  c,
  onClick,
  target,
}: Props) {
  // Detect if URL is internal (starts with '/') or external
  const isInternalRoute = to.startsWith('/');
  const linkTarget = target ?? (isInternalRoute ? undefined : '_blank');

  return (
    <Text
      component={NavLink}
      target={linkTarget}
      to={to}
      size={size}
      fw={fw}
      onClick={onClick}
      c={c}
    >
      {children}
    </Text>
  );
}
